import type { FaqItem, FaqTag } from './types';

type TagLevel = 1 | 2;

function unique(values: string[]) {
  return Array.from(new Set(values.filter(Boolean)));
}

function getStoredTagIds(item: FaqItem, level: TagLevel) {
  return level === 1 ? item.primary_tag_ids : item.secondary_tag_ids;
}

function getLegacyTagNames(item: FaqItem, level: TagLevel) {
  return level === 1 ? item.primary_tags : item.secondary_tags;
}

export function tagNamesFromIds(ids: string[] | undefined, tags: FaqTag[], level: TagLevel) {
  const tagById = new Map(tags.filter((tag) => tag.level === level).map((tag) => [tag.id, tag.name]));
  return unique((ids ?? []).map((id) => tagById.get(id) ?? ''));
}

export function tagIdsFromNames(names: string[] | undefined, tags: FaqTag[], level: TagLevel) {
  const tagByName = new Map(tags.filter((tag) => tag.level === level).map((tag) => [tag.name, tag.id]));
  return unique((names ?? []).map((name) => tagByName.get(name) ?? ''));
}

export function faqTagIds(item: FaqItem, tags: FaqTag[], level: TagLevel) {
  const storedIds = getStoredTagIds(item, level);
  if (Array.isArray(storedIds) && storedIds.length > 0) return unique(storedIds);
  return tagIdsFromNames(getLegacyTagNames(item, level), tags, level);
}

export function faqTagLabels(item: FaqItem, tags: FaqTag[], level: TagLevel) {
  const storedIds = getStoredTagIds(item, level);
  if (Array.isArray(storedIds) && storedIds.length > 0) {
    return tagNamesFromIds(storedIds, tags, level);
  }
  return unique(getLegacyTagNames(item, level) ?? []);
}

export function tagPayloadFromIds(primaryTagIds: string[], secondaryTagIds: string[], tags: FaqTag[]) {
  return {
    primary_tag_ids: unique(primaryTagIds),
    secondary_tag_ids: unique(secondaryTagIds),
    primary_tags: tagNamesFromIds(primaryTagIds, tags, 1),
    secondary_tags: tagNamesFromIds(secondaryTagIds, tags, 2),
  };
}
